// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.news-form-container {
    padding: 20px;
    display: flex;
    gap: 40px;
}

.news-form-section {
    flex: 0 0 500px;
}

.news-form-title {
    margin-bottom: 30px;
    color: #1e3c72;
    font-size: 24px;
    font-weight: 500;
}

.form-group {
    margin-bottom: 20px;
}

.form-label {
    display: block;
    margin-bottom: 8px;
    color: #333;
    font-size: 14px;
    font-weight: 500;
}

.form-label-error {
    color: #dc2626;
}

.form-error {
    padding: 12px;
    background-color: #fff5f5;
    color: #dc2626;
    border-radius: 4px;
    margin-bottom: 20px;
    font-size: 14px;
    border: 1px solid #fecaca;
}

.form-select {
    width: 150px;
    padding: 8px 12px;
    border-radius: 4px;
    border: 1px solid #ddd;
    font-size: 14px;
    outline: none;
    background-color: white;
    cursor: pointer;
}

.form-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 20px;
    margin-top: 30px;
}

.form-checkbox {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #666;
    cursor: pointer;
}

.form-input {
    width: 100%;
    padding: 8px 12px;
    border-radius: 4px;
    border: 1px solid #ddd;
    font-size: 14px;
    outline: none;
    transition: all 0.2s ease;
}

.form-input.error {
    border: 1px solid #dc2626;
    background-color: #fff5f5;
}

.form-input:focus {
    border-color: #2a5298;
    box-shadow: 0 0 0 2px rgba(42, 82, 152, 0.1);
}

.character-counter {
    position: absolute;
    top: -24px;
    right: 0;
    font-size: 14px;
    transition: color 0.2s ease;
}

.btn {
    padding: 10px 24px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
}

.btn-primary {
    background-color: #2a5298;
    color: white;
    border: none;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.btn-secondary {
    background-color: white;
    color: #666;
    border: 1px solid #ddd;
}

.btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

/* Preview styles */
.preview-container {
    flex: 1 1;
}

.preview-title {
    margin-bottom: 20px;
    color: #1e3c72;
    font-size: 20px;
    font-weight: 500;
}

.preview-content {
    max-width: 300px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}

.aspect-ratio-buttons {
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
}

.aspect-ratio-btn {
    display: inline-block;
    padding: 4px 12px;
    background-color: #f3f4f6;
    border-radius: 4px;
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.aspect-ratio-btn.active {
    background-color: #fff;
    color: #2a5298;
}

.error-message {
    font-size: 12px;
    color: #dc2626;
    margin-top: 4px;
}

/* Стили из InputWrapper.css */
.label {
    display: block;
    margin-bottom: 8px;
    color: #333;
    font-size: 14px;
    font-weight: 500;
}

.label-error {
    color: #dc2626;
}

/* Стили для UTM-меток */
.utm-select {
    position: relative;
}

.utm-select-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    cursor: pointer;
    background-color: white;
    transition: all 0.2s;
    font-size: 14px;
}

.utm-select-header:hover {
    border-color: #2a5298;
}

.utm-options {
    position: absolute;
    margin-top: 4px;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06);
    z-index: 10;
    overflow: hidden;
}

.utm-option {
    padding: 8px 12px;
    cursor: pointer;
    transition: background-color 0.2s;
    font-size: 14px;
}

.utm-option:hover {
    background-color: #f9fafb;
}

.utm-preview {
    margin-top: 16px;
    padding: 12px;
    background-color: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    font-size: 14px;
}

.utm-preview-url {
    margin-top: 20px;
    padding: 12px;
    background-color: #f0f5ff;
    border: 1px solid #d0e0ff;
    border-radius: 6px;
    font-size: 14px;
}

.utm-preview-url .utm-preview-header {
    color: #2a5298;
    font-weight: 500;
    margin-bottom: 10px;
    font-size: 14px;
}

.utm-preview p {
    margin-bottom: 8px;
    font-size: 14px;
}

.utm-params {
    background-color: white;
    padding: 8px 10px;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    font-family: monospace;
    font-size: 13px;
    margin: 8px 0;
    word-break: break-all;
    overflow-wrap: break-word;
}

.utm-preview-url .utm-params {
    background-color: white;
    border: 1px solid #c0d0f0;
    word-break: break-all;
    max-width: 100%;
    overflow-x: auto;
}

.utm-description {
    font-size: 13px;
    color: #6b7280;
    line-height: 1.4;
    margin-top: 8px;
}

.utm-description ul {
    margin-left: 20px;
    list-style-type: disc;
    margin-top: 6px;
    margin-bottom: 6px;
}

.utm-description li {
    margin-bottom: 4px;
}

.utm-example {
    background-color: #f8fafc;
    border: 1px solid #e5e7eb;
    padding: 12px 16px;
    border-radius: 8px;
    margin-top: 16px;
}

/* Стили для блока предпросмотра URL */
.url-preview {
    margin-top: 16px;
    padding: 16px;
    background-color: #e8f4ff;
    border: 1px solid #b3d8ff;
    border-left: 4px solid #2563eb;
    border-radius: 6px;
    font-size: 14px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
}

.url-preview:hover {
    background-color: #dceeff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
}

.url-preview-header {
    color: #1e40af;
    font-weight: 600;
    font-size: 15px;
    display: flex;
    align-items: center;
}

.url-preview-header::before {
    content: '🔗';
    margin-right: 8px;
}

.url-preview .utm-params {
    background-color: white;
    padding: 10px 12px;
    border: 1px solid #b3d8ff;
    border-radius: 4px;
    font-family: monospace;
    font-size: 13px;
    margin: 8px 0;
    word-break: break-all;
    overflow-wrap: break-word;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
}

.url-example-container {
    margin-top: 12px;
}

.url-original, .url-transformed {
    width: 100%;
    overflow-x: auto;
    font-family: monospace;
}

.url-transformed {
    background-color: #eff6ff;
    border-color: #bfdbfe;
} `, "",{"version":3,"sources":["webpack://./src/styles/NewsForm.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,SAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA,8BAA8B;AAC9B;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,2EAA2E;IAC3E,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,sCAAsC;AACtC;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,qBAAqB;IACrB,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB","sourcesContent":[".news-form-container {\n    padding: 20px;\n    display: flex;\n    gap: 40px;\n}\n\n.news-form-section {\n    flex: 0 0 500px;\n}\n\n.news-form-title {\n    margin-bottom: 30px;\n    color: #1e3c72;\n    font-size: 24px;\n    font-weight: 500;\n}\n\n.form-group {\n    margin-bottom: 20px;\n}\n\n.form-label {\n    display: block;\n    margin-bottom: 8px;\n    color: #333;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.form-label-error {\n    color: #dc2626;\n}\n\n.form-error {\n    padding: 12px;\n    background-color: #fff5f5;\n    color: #dc2626;\n    border-radius: 4px;\n    margin-bottom: 20px;\n    font-size: 14px;\n    border: 1px solid #fecaca;\n}\n\n.form-select {\n    width: 150px;\n    padding: 8px 12px;\n    border-radius: 4px;\n    border: 1px solid #ddd;\n    font-size: 14px;\n    outline: none;\n    background-color: white;\n    cursor: pointer;\n}\n\n.form-actions {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 20px;\n    margin-top: 30px;\n}\n\n.form-checkbox {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    color: #666;\n    cursor: pointer;\n}\n\n.form-input {\n    width: 100%;\n    padding: 8px 12px;\n    border-radius: 4px;\n    border: 1px solid #ddd;\n    font-size: 14px;\n    outline: none;\n    transition: all 0.2s ease;\n}\n\n.form-input.error {\n    border: 1px solid #dc2626;\n    background-color: #fff5f5;\n}\n\n.form-input:focus {\n    border-color: #2a5298;\n    box-shadow: 0 0 0 2px rgba(42, 82, 152, 0.1);\n}\n\n.character-counter {\n    position: absolute;\n    top: -24px;\n    right: 0;\n    font-size: 14px;\n    transition: color 0.2s ease;\n}\n\n.btn {\n    padding: 10px 24px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.2s ease;\n}\n\n.btn-primary {\n    background-color: #2a5298;\n    color: white;\n    border: none;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.btn-secondary {\n    background-color: white;\n    color: #666;\n    border: 1px solid #ddd;\n}\n\n.btn:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n/* Preview styles */\n.preview-container {\n    flex: 1;\n}\n\n.preview-title {\n    margin-bottom: 20px;\n    color: #1e3c72;\n    font-size: 20px;\n    font-weight: 500;\n}\n\n.preview-content {\n    max-width: 300px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 20px;\n    background-color: white;\n    border-radius: 8px;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);\n}\n\n.aspect-ratio-buttons {\n    display: flex;\n    gap: 8px;\n    margin-bottom: 8px;\n}\n\n.aspect-ratio-btn {\n    display: inline-block;\n    padding: 4px 12px;\n    background-color: #f3f4f6;\n    border-radius: 4px;\n    font-size: 14px;\n    color: #666;\n    margin-bottom: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.aspect-ratio-btn.active {\n    background-color: #fff;\n    color: #2a5298;\n}\n\n.error-message {\n    font-size: 12px;\n    color: #dc2626;\n    margin-top: 4px;\n}\n\n/* Стили из InputWrapper.css */\n.label {\n    display: block;\n    margin-bottom: 8px;\n    color: #333;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.label-error {\n    color: #dc2626;\n}\n\n/* Стили для UTM-меток */\n.utm-select {\n    position: relative;\n}\n\n.utm-select-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px 12px;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    cursor: pointer;\n    background-color: white;\n    transition: all 0.2s;\n    font-size: 14px;\n}\n\n.utm-select-header:hover {\n    border-color: #2a5298;\n}\n\n.utm-options {\n    position: absolute;\n    margin-top: 4px;\n    left: 0;\n    right: 0;\n    background: white;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06);\n    z-index: 10;\n    overflow: hidden;\n}\n\n.utm-option {\n    padding: 8px 12px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    font-size: 14px;\n}\n\n.utm-option:hover {\n    background-color: #f9fafb;\n}\n\n.utm-preview {\n    margin-top: 16px;\n    padding: 12px;\n    background-color: #f9fafb;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    font-size: 14px;\n}\n\n.utm-preview-url {\n    margin-top: 20px;\n    padding: 12px;\n    background-color: #f0f5ff;\n    border: 1px solid #d0e0ff;\n    border-radius: 6px;\n    font-size: 14px;\n}\n\n.utm-preview-url .utm-preview-header {\n    color: #2a5298;\n    font-weight: 500;\n    margin-bottom: 10px;\n    font-size: 14px;\n}\n\n.utm-preview p {\n    margin-bottom: 8px;\n    font-size: 14px;\n}\n\n.utm-params {\n    background-color: white;\n    padding: 8px 10px;\n    border: 1px solid #e5e7eb;\n    border-radius: 4px;\n    font-family: monospace;\n    font-size: 13px;\n    margin: 8px 0;\n    word-break: break-all;\n    overflow-wrap: break-word;\n}\n\n.utm-preview-url .utm-params {\n    background-color: white;\n    border: 1px solid #c0d0f0;\n    word-break: break-all;\n    max-width: 100%;\n    overflow-x: auto;\n}\n\n.utm-description {\n    font-size: 13px;\n    color: #6b7280;\n    line-height: 1.4;\n    margin-top: 8px;\n}\n\n.utm-description ul {\n    margin-left: 20px;\n    list-style-type: disc;\n    margin-top: 6px;\n    margin-bottom: 6px;\n}\n\n.utm-description li {\n    margin-bottom: 4px;\n}\n\n.utm-example {\n    background-color: #f8fafc;\n    border: 1px solid #e5e7eb;\n    padding: 12px 16px;\n    border-radius: 8px;\n    margin-top: 16px;\n}\n\n/* Стили для блока предпросмотра URL */\n.url-preview {\n    margin-top: 16px;\n    padding: 16px;\n    background-color: #e8f4ff;\n    border: 1px solid #b3d8ff;\n    border-left: 4px solid #2563eb;\n    border-radius: 6px;\n    font-size: 14px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    transition: all 0.3s ease;\n}\n\n.url-preview:hover {\n    background-color: #dceeff;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);\n}\n\n.url-preview-header {\n    color: #1e40af;\n    font-weight: 600;\n    font-size: 15px;\n    display: flex;\n    align-items: center;\n}\n\n.url-preview-header::before {\n    content: '🔗';\n    margin-right: 8px;\n}\n\n.url-preview .utm-params {\n    background-color: white;\n    padding: 10px 12px;\n    border: 1px solid #b3d8ff;\n    border-radius: 4px;\n    font-family: monospace;\n    font-size: 13px;\n    margin: 8px 0;\n    word-break: break-all;\n    overflow-wrap: break-word;\n    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.url-example-container {\n    margin-top: 12px;\n}\n\n.url-original, .url-transformed {\n    width: 100%;\n    overflow-x: auto;\n    font-family: monospace;\n}\n\n.url-transformed {\n    background-color: #eff6ff;\n    border-color: #bfdbfe;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
